// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionListComponent__root--2cYpX"};